var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.714 9c-1.676 0-3.504.893-5.434 2.653a23.075 23.075 0 0 0-2.29 2.427l-.004-.004-.01.011C13.896 11.674 11.08 9 8.294 9c-3.3.012-6.093 2.246-6.976 5.29a2.393 2.393 0 0 0-.115.335A7.585 7.585 0 0 0 1 16.334c0 4.068 3.262 7.37 7.286 7.37 1.676 0 3.504-.892 5.433-2.652a23.084 23.084 0 0 0 2.297-2.436s-.94-1.058-1.967-2.193c-.56.688-1.359 1.62-2.285 2.461-1.714 1.556-2.844 1.888-3.479 1.888-2.412 0-4.366-1.977-4.366-4.426 0-2.423 1.954-4.4 4.366-4.425.073.001.155.006.248.02 1.506.6 2.772 1.622 3.111 1.944a41.706 41.706 0 0 1 2.412 2.538 325.283 325.283 0 0 1 1.968 2.194l.012-.015c2.089 2.415 4.905 5.091 7.692 5.091 3.366-.011 6.206-2.337 7.028-5.477a1.63 1.63 0 0 0 .039-.133A7.587 7.587 0 0 0 31 16.371c-.013-4.067-3.275-7.37-7.286-7.37zM23.59 20.78c.044.002.085.004.124.004 2.411-.026 4.366-2.003 4.366-4.426 0-2.448-1.955-4.425-4.366-4.425-.648 0-1.765.32-3.479 1.888-.922.839-1.72 1.766-2.278 2.453a41.644 41.644 0 0 0 2.409 2.534c.348.331 1.667 1.386 3.224 1.972z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcp);
export default __webpack_public_path__ + "static/media/ICP.f8a5e3ad1baa95e507ebf4e89dc87c6c.svg";
export { ForwardRef as ReactComponent };